import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '@/lib/supabase';
import { useAuth } from '@/hooks/useAuth';
import { guardarDestino } from '@/lib/destino';
import { useConvites } from './context';
import CartaoConvite from './components/CartaoConvite';
import Dica from '@/components/feature/Dica';

export default function ConvitesPage() {
  const navigate = useNavigate();
  const { user, pronto } = useAuth();
  const { convites, carregando } = useConvites();

  useEffect(() => {
    if (!pronto) return;
    if (!user) {
      guardarDestino();
      navigate(`/entrar?voltar=${encodeURIComponent('/convites')}`, { replace: true });
    }
  }, [navigate, pronto, user]);

  if (carregando) {
    return (
      <div className="min-h-screen bg-background-100">
        <div className="mx-auto w-full max-w-[720px] px-4 py-8">
          <div className="h-8 w-40 animate-pulse rounded bg-secondary-100" />
          <div className="mt-2 h-4 w-64 animate-pulse rounded bg-secondary-100" />
          <div className="mt-6 space-y-3">
            <div className="h-28 w-full animate-pulse rounded-lg bg-secondary-100" />
            <div className="h-28 w-full animate-pulse rounded-lg bg-secondary-100" />
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-background-100">
      <div className="mx-auto w-full max-w-[720px] px-4 py-8">
        <div className="flex items-center gap-2"><h1 className="text-[28px] font-normal text-foreground-950">Convites</h1><Dica id="convites" /></div>
        <p className="mt-1 text-sm text-secondary-500">
          Convites para você ajudar a administrar eventos.
        </p>

        {convites.length === 0 ? (
          <div className="mt-6 rounded-lg border border-secondary-200 bg-white p-10 text-center">
            <span className="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-secondary-100 text-secondary-400">
              <i className="ri-mail-line text-xl" />
            </span>
            <p className="mt-3 text-[15px] text-foreground-800">
              Você não tem convites em aberto.
            </p>
          </div>
        ) : (
          <div className="mt-6 space-y-3">
            {convites.map((c) => (
              <CartaoConvite key={c.convite_id} convite={c} />
            ))}
          </div>
        )}
      </div>
    </div>
  );
}